import { IfpEmploymentType, IfpOccupation, IfpWorkingHours, PrimaryReasonForIfp } from '@shared/sec-loans'
import { LocalizedString } from '@shared/types'

export interface IfpLoan {
  creditId: string
  iban: string
  balance: number
  description: LocalizedString
  principalExemptionMonthsLeft?: number
  otherDebtors: {
    id: string
    ssn: string
    name: string
  }[]
}

export enum IfpApplicationState {
  Draft = 'Draft',
  WaitingForCoDebtor = 'WaitingForCoDebtor',
  ReturnedByCoDebtor = 'ReturnedByCoDebtor',
  Cancelled = 'Cancelled',
  Sending = 'Sending',
  WaitingForResend = 'WaitingForResend',
  Rejected = 'Rejected',
  Pending = 'Pending',
  Accepted = 'Accepted',
}

export interface IfpApplicationMetadata
  extends Pick<IfpApplication, 'applicationId' | 'updated' | 'state' | 'stateChangedBy' | 'actionsNeeded' | 'primary'> {
  loan: Pick<IfpLoan, 'balance' | 'description' | 'creditId'>
}

/** TODO: DIG-6173 - define the data structure of application  */
export interface IfpApplicationData {
  basicInfo: {
    durationInMonths: number
    startsImmediately: boolean
    startDate?: string
    primaryReason: PrimaryReasonForIfp
    primaryReasonOther?: string
    hasFinancialDifficulties: boolean
  }
  householdInfo: {
    numberOfAdults: number
    numberOfChildren: number
  }
  applicantInfos: {
    phoneNumber: string
    occupation: IfpOccupation
    grossSalary?: number
    netSalary?: number
    employmentType?: IfpEmploymentType
    employer?: string
    workingHours?: IfpWorkingHours
    profession?: string
    employmentStartDate?: string
    employmentEndDate?: string
  }[]
}

export interface IfpApplication<TData = IfpApplicationData> {
  applicationId: string
  created: number
  updated: number
  version: string
  actionsNeeded: string[] | null
  primary: string
  state: IfpApplicationState
  stateChangedBy: string
  data?: Partial<TData>
}

export interface IfpApplicationIdPathParam {
  applicationId: string
}

export enum IfpApplicationAction {
  Submit = 'submit',
  Accept = 'accept',
  Return = 'return',
  Cancel = 'cancel',
}

export interface IfpApplicationActionPathParams extends IfpApplicationIdPathParam {
  action: IfpApplicationAction
}

export type IfpGetApplicationResponse = IfpApplication

/** ApplicationId */
export type IfpCreateApplicationResponse = string

export interface IfpCreateApplicationRequest {
  creditId: IfpLoan['creditId']
  data?: Partial<IfpApplicationData>
}

export interface IfpUpdateApplicationRequest {
  data: Partial<IfpApplicationData>
}
